import React from "react";

const Header = () => {
  return (
    <header>
      <div className="intro-logo jumbo-bg">
        <img
          style={{ width: "15%", height: "43%" }}
          alt="..."
          src={require("src/assets/img/labasservice2.png").default}
        />
        <h1>Transaction Completed Successfully</h1>
        <h3>Thank you for your billing.</h3>
        <img
          src="https://bootstrapmade.com/demo/themes/eStartup/img/hero-img.png"
          className=""
          alt=""
        />
        <div className="intro-button">
          <a href={`${window.location.origin}`}>Dashboard</a>
        </div>
      </div>

      <style jsx>{`
        .checkmark {
          display: inline-block;
          width: 22px;
          height: 22px;
          -ms-transform: rotate(45deg); /* IE 9 */
          -webkit-transform: rotate(45deg); /* Chrome, Safari, Opera */
          transform: rotate(45deg);
        }

        .checkmark_stem {
          position: absolute;
          width: 3px;
          height: 9px;
          background-color: #ccc;
          left: 11px;
          top: 6px;
        }

        .checkmark_kick {
          position: absolute;
          width: 3px;
          height: 3px;
          background-color: #ccc;
          left: 8px;
          top: 12px;
        }
        header {
          margin-bottom: 1rem;
          height: 100vh;
        }
        .intro-logo {
          display: flex;
          position: absolute;
          top: 5em;
          bottom: 0;
          left: 0;
          right: 0;
          flex-direction: column;
          justify-content: space-evenly;
          align-items: center;
          text-align: center;
        }

        .intro-logo h1 {
          font-size: 1.8em;
          font-weight: 400;
          font-family: "Philosopher", sans-serif;
          color: var(--brand-color);
        }
        @media (min-width: 768px) {
          .intro-logo h1 {
            font-size: 3.5em;
          }
        }
        .intro-logo h3 {
          font-size: 1rem;
          font-weight: 300;
          color: var(--gray-color-1);
          margin-bottom: 3em;
        }

        .intro-logo img {
          max-width: 95%;
          height: auto;
        }
        .company-icons__item + .company-icons__item {
          margin-left: 1rem;
        }
        @media (min-width: 575px) {
          .company-icons__item + .company-icons__item {
            margin-left: 2rem;
          }
        }
        .company-icons__item i {
          margin-right: 5px;
        }
        .intro-button {
          margin-top: 2.3em;
          margin-bottom: 3em;
        }
        .intro-button a {
          padding: 0.65em 2.6em;
          border-radius: 20px;
          color: var(--brand-color);
          border: 1.8px solid var(--brand-color);
          background: white;
          transition: all 0.5s;
        }
        .intro-button a:hover {
          background-color: var(--brand-color);
          color: white;
        }

        .company-icons {
          color: var(--gray-color-2);
          font-size: 0.95em;
        }
        .company-icons__item {
          transition: all 0.5s;
        }
        .company-icons__item:hover {
          color: var(--brand-color);
          cursor: pointer;
        }
      `}</style>
    </header>
  );
};

export default Header;
